module.exports = __webpack_public_path__ + "static/img/lpfw_lpfw.579f396.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/lpfw_lpfw.png
// module id = 5JTG
// module chunks = 0